import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { BarChart3, Bot, ChevronLeft, ChevronRight, FileText, LogOut, MessageSquare, Plug, Users } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import PainelLogin from "./PainelLogin";
import styles from "./PainelLayout.module.css";
import logoFull from "../../assets/images/logo hl software ( letra banca ).png";
import logoIcon from "../../assets/images/logo hl software ( reduzida branca ).png";

const NAV_ITEMS = [
    { to: "/painel/analytics", icon: <BarChart3 size={20} />, label: "Acessos" },
    { to: "/painel/crm",     icon: <Users size={20} />,   label: "CRM"     },
    {
        to: "/painel/blog",
        icon: <FileText size={20} />,
        label: "Blog",
        children: [
            { to: "/painel/comentarios", icon: <MessageSquare size={18} />, label: "Comentários" },
        ],
    },
    { to: "/painel/agentes", icon: <Bot size={20} />,      label: "Agentes" },
    { to: "/painel/integracoes", icon: <Plug size={20} />, label: "Integrações" },
];

export default function PainelLayout() {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    if (!isAuthenticated) {
        return <PainelLogin />;
    }

    const handleLogout = () => {
        logout();
        navigate("/painel");
    };

    return (
        <div className={styles.shell}>
            <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ""}`}>

                {/* Cabeçalho: logo + botão de toggle */}
                <div className={styles.sidebarHeader}>
                    <div className={styles.logoWrap}>
                        <img
                            src={logoFull}
                            alt="HL Software"
                            className={`${styles.logoFull}`}
                        />
                        <img
                            src={logoIcon}
                            alt="HL"
                            className={`${styles.logoIcon}`}
                        />
                    </div>
                    <button
                        type="button"
                        className={styles.toggleButton}
                        onClick={() => setCollapsed((prev) => !prev)}
                        aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
                        title={collapsed ? "Expandir menu" : "Recolher menu"}
                    >
                        {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
                    </button>
                </div>

                {/* Navegação */}
                <nav className={styles.sidebarNav}>
                    {NAV_ITEMS.map(({ to, icon, label, children }) => (
                        <React.Fragment key={to}>
                            <NavLink
                                to={to}
                                data-label={label}
                                className={({ isActive }) =>
                                    `${styles.navItem} ${isActive ? styles.navItemActive : ""}`
                                }
                            >
                                <span className={styles.navIcon}>{icon}</span>
                                <span className={styles.navLabel}>{label}</span>
                            </NavLink>

                            {children?.map((child) => (
                                <NavLink
                                    key={child.to}
                                    to={child.to}
                                    data-label={child.label}
                                    className={({ isActive }) =>
                                        `${styles.navItem} ${styles.navSubItem} ${isActive ? styles.navItemActive : ""}`
                                    }
                                >
                                    <span className={styles.navIcon}>{child.icon}</span>
                                    <span className={styles.navLabel}>{child.label}</span>
                                </NavLink>
                            ))}
                        </React.Fragment>
                    ))}
                </nav>

                {/* Logout */}
                <button
                    type="button"
                    className={styles.logoutButton}
                    onClick={handleLogout}
                    data-label="Sair"
                    title="Sair"
                >
                    <span className={styles.navIcon}><LogOut size={20} /></span>
                    <span className={styles.navLabel}>Sair</span>
                </button>

            </aside>

            <main className={styles.content}>
                <Outlet />
            </main>
        </div>
    );
}
